/**
 * Removes https:// and www. from the beginning of a URL for display purposes
 * e.g. https://www.monday.com -> monday.com
 * e.g. www.monday.com -> monday.com
 * e.g. https://monday.com -> monday.com
 */
export const trimUrlForDisplay = (url: string): string => {
  if (!url) return url;
  return url.replace(/^https?:\/\/(www\.)?/, "");
};
